import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Services", href: "#services" },
  { label: "Results", href: "#results" },
  { label: "Brands", href: "#brands" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="relative w-10 h-10 rounded-xl border border-[#C9A227]/40 grid place-items-center overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-[#C9A227]/30 to-[#047857]/20" />
            <span className="relative font-bold text-[#F4D983]">S</span>
          </div>
          <div className="leading-tight">
            <div className="font-semibold tracking-wide">SYR <span className="text-gold-gradient">Mediaworks</span></div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-white/50">Private Limited</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="relative text-sm text-white/70 hover:text-white px-4 py-2 rounded-full transition-colors"
            >
              {l.label}
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-gradient-to-r from-transparent via-[#C9A227] to-transparent opacity-0 hover:opacity-100 transition-opacity" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="#contact" className="btn-gold text-sm !py-2.5 !px-5">
            Start Partnership <ArrowUpRight size={16} />
          </a>
        </div>

        <button className="lg:hidden text-white p-2" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-black/95 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 border-b border-white/5 text-white/80 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-gold mt-3 justify-center">
              Start Partnership <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
